'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { OutboundSsoListContent } from '@/features/software-sso/components/OutboundSsoListContent';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/idp/_layout/settings/sso/')({
  component: IdpSsoSettingsPage
});
function IdpSsoSettingsPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.idp.settings.sso'
  });
  return <VStack className="gap-4 min-h-0 h-full">
      <VStack className="gap-1">
        <Text variant="h3">{t('title')}</Text>
        <Text variant="pSmall" className="text-neutral-muted-on-fill">
          {t('description')}
        </Text>
      </VStack>
      <OutboundSsoListContent className="px-0 py-0" fillScreen={false} />
    </VStack>;
}